import Vue from 'vue'
import { getToken } from '@/utils/auth'

let refreshPromise = null

function getKeycloakClient() {
  const keycloak = Vue.prototype.$keycloak
  if (!keycloak) return null
  if (typeof keycloak.updateToken === 'function') return keycloak
  if (keycloak.keycloak && typeof keycloak.keycloak.updateToken === 'function') {
    return keycloak.keycloak
  }
  return null
}

export function getCurrentAccessToken() {
  const keycloak = getKeycloakClient()
  return (keycloak && keycloak.token) || getToken()
}

export function canRefreshKeycloakToken() {
  const keycloak = getKeycloakClient()
  return Boolean(keycloak && keycloak.authenticated !== false)
}

/**
 * 合并并发刷新，避免多个 403 同时触发重复的 Keycloak token 请求。
 */
export function refreshKeycloakToken(minValidity = 70) {
  const keycloak = getKeycloakClient()
  if (!keycloak || keycloak.authenticated === false) {
    return Promise.resolve({
      attempted: false,
      refreshed: false,
      token: getCurrentAccessToken()
    })
  }
  if (refreshPromise) return refreshPromise

  refreshPromise = keycloak.updateToken(minValidity)
    .then(refreshed => ({
      attempted: true,
      refreshed,
      token: keycloak.token || getToken()
    }))
    .finally(() => {
      refreshPromise = null
    })
  return refreshPromise
}
